module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"corporateProfile":"・会社概要（株式会社建設技術研究所）","termsOfUse":"・利用規約","trademark":"「RisKma」は株式会社建設技術研究所の登録商標です。"},"en":{"corporateProfile":"・Corporate Profile (CTI Engineering, Ltd.)","termsOfUse":"・Terms of Use","trademark":"\\"RisKma\\" is a registered trademark of CTI Engineering Corporation."}}')
  delete Component.options._Ctor
}
